import React from 'react';
import hero from '../../content/hero.json';

const PageTitleHome = () => {
  return (
    <section name="page-title" id="page-title" className="page-title block with-img" style={ { backgroundImage: `url(${hero.image})` } }>
      <div className="wrapper text-center d-flex">
        <div className="align-self-center w-100">
          <div className="title">
            <h1 className="large">{hero.title}</h1>
          </div>

          <div className="description spacer p-top-sm">
            <p>{hero.subtitle}</p>
          </div>

        </div>
      </div>

    </section>
  );
};

export default PageTitleHome;
